import axios from "axios"
import baseURL from "../configs/api"

export const post_Customer = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}Customer?userId=${userId}`,
        method: "POST",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const put_Customer = async (data: any, userId: number, tenantId: string) => {
    const response = await axios({
        url: `${baseURL}Customer?userId=${userId}`,
        method: "PUT",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        withCredentials: true,
        data: data
    });
    return response.data;
}

export const getCustomers = (tenantId: string) => {
    return getFetch("Customer", tenantId);
}

export const getCustomer = (primaryKey: number, tenantId: string) => {
    return getFetch(`Customer/${primaryKey}`, tenantId);
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}